export default {
  methods: {
    scrollUp () {
      window.scrollTo(0, document.getElementById('app').offsetTop)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/help.js